export const myFleetContextTypes = {
  RESET_MYFLEET_CONTEXT: "context/RESET_MYFLEET_CONTEXT",
  SET_SORTING: "context/SET_SORTING",
} as const;

export type MyFleetContextAction =
  | { type: typeof myFleetContextTypes.SET_SORTING; payload: { by: string; descending?: boolean } }
  | { type: typeof myFleetContextTypes.RESET_MYFLEET_CONTEXT };
